import { defineStore } from 'pinia';
import ShippingReturnReason from '../../settings/entities/shipping-return-reason';
import OrdersService from '../service';
import OrderReturn from '../entities/order-return';
import { getMarketplaceMeta } from '@/v2/utils/marketplaces';

export const useCreateReturnDialogStore = defineStore('createReturnDialog', {
	state: () => ({
		isOpen: false,
		step: 1,
		selectedOrder: null,
		products: [],
		returnReasons: [],
		selectedProducts: [],
		pickupLocation: null,
		shippingCompaniesLoading: false,
		shippingCompanies: [],
		selectedCompany: null,
		loading: false,
		returnReason: undefined,
	}),
	getters: {
		isSelectedProduct(state) {
			return (id) => {
				return state.selectedProducts.some((productId) => productId == id);
			};
		},
		marketplaceId(state) {
			return state.selectedOrder?.marketplace_id;
		},
	},
	actions: {
		async fetchReturnReasons() {
			const { data } = await ShippingReturnReason.getReasons({ per_page: 100 });
			this.returnReasons = data;
		},
		async fetchShippingCompanies() {
			this.shippingCompanies = [];
			this.shippingCompaniesLoading = true;
			try {
				const data = await OrdersService.getDeliveryCompanies({
					customer_id: this.selectedOrder.customer_id,
					weight: this.selectedOrder.total_weight || 1,
					pickup_location_id: this.pickupLocation,
				});
				this.shippingCompanies = data;
			} finally {
				this.shippingCompaniesLoading = false;
			}
		},
		async createRequest() {
			this.loading = true;
			try {
				const data = {
					pickup_location_id: this.pickupLocation,
					date: moment(new Date()).locale('en').format('YYYY-MM-DD'),
					order_items: this.products
						.filter(
							(p) =>
								this.selectedProducts.some((id) => p.variant_id == id) ||
								!getMarketplaceMeta(this.marketplaceId).canCreateReturnByItem,
						)
						.map((product) => ({
							variant_id: product.variant_id,
							quantity: product.selectedQty,
							return_reason_id: product.selectedReason || this.returnReason || undefined,
						})),
					shipment_id: this.selectedOrder.shipment_id,
					return_reason: this.returnReason || undefined,
				};
				await OrderReturn.createReturn(this.selectedOrder.id, data);
				this.isOpen = false;
			} finally {
				this.loading = false;
			}
		},
		openDialog() {
			this.isOpen = true;
			this.fetchReturnReasons();
		},
		selectOrder(order) {
			this.selectedProducts = [];
			this.selectedOrder = order;
			this.products = order.products.map((product) => ({
				...product,
				selectedReason: null,
				selectedQty: product.max_quantity_to_return,
			}));
		},
		selectPickupLocation(id) {
			this.pickupLocation = id;
			this.fetchShippingCompanies();
		},
		resetData() {
			this.isOpen = false;
			this.loading = false;
			this.shippingCompaniesLoading = false;
			this.step = 1;
			this.pickupLocation = null;
			this.selectedOrder = null;
			this.selectedCompany = null;
			this.returnReason = undefined;
			this.products = [];
			this.selectedProducts = [];
			this.shippingCompanies = [];
		},
	},
});
